"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(paymentDetail) {
    var _a;
    const { order_status_cd_id, order_cancels } = paymentDetail;
    if (order_status_cd_id === 'ORDER_STATUS_01') {
        return 'paymentAwait';
    }
    else {
        const lastRefundStatus = (_a = order_cancels.slice().pop()) === null || _a === void 0 ? void 0 : _a.order_cancel_status_cd_id;
        switch (lastRefundStatus) {
            case 'REFUND_STATUS_00':
                return 'refundRequest';
            case 'REFUND_STATUS_03':
                return 'refundComplete';
            case 'REFUND_STATUS_04':
                return 'refundRefuse';
            case 'REFUND_STATUS_05':
                return 'refundSecondComplete';
            default:
                return 'paymentComplete';
        }
    }
}
exports.default = default_1;
